"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withHtml = exports.insertHtml = void 0;
var react_1 = __importStar(require("react"));
var Ant = __importStar(require("antd"));
var styled_components_1 = __importDefault(require("styled-components"));
var slate_1 = require("slate");
var sanitize_html_1 = __importDefault(require("sanitize-html"));
function _sanitizeHtml(value) {
  var sanitizeOptions = {
    allowedAttributes: {
      '*': ['href', 'align', 'alt', 'center', 'bgcolor', 'style']
    }
  };
  var out = sanitize_html_1.default(value, sanitizeOptions);
  console.log('dbg', out);
  return out;
}
function isHtml(value) {
  var re = /(<\w*)((\s\/>)|(.*<\/\w*>))/;
  return re.test(value);
}
var insertHtml = function (editor, value) {
  var text = {
    text: ''
  };
  var image = {
    type: 'html',
    value: _sanitizeHtml(value),
    children: [text]
  };
  slate_1.Transforms.select(editor, editor._onBlurSelection);
  slate_1.Transforms.insertNodes(editor, image);
  // workaround, let user can select pure text rather than the image block
  slate_1.Transforms.insertNodes(editor, {
    type: 'p',
    children: [{
      text: ''
    }]
  });
};
exports.insertHtml = insertHtml;
var withHtml = function (editor) {
  var insertData = editor.insertData,
    isVoid = editor.isVoid;
  editor.isVoid = function (element) {
    return element.type === 'html' ? true : isVoid(element);
  };
  editor.insertData = function (data) {
    var text = data.getData('text/plain');
    if (isHtml(text)) {
      insertHtml(editor, text);
    } else {
      insertData(data);
    }
  };
  return editor;
};
exports.withHtml = withHtml;
function HtmlModal(props) {
  var _a = react_1.useState(''),
    value = _a[0],
    setValue = _a[1];
  var visible = props.visible,
    onCancel = props.onCancel,
    onInsert = props.onInsert;
  return react_1.default.createElement(Ant.Modal, {
    className: "custom-modal",
    title: "\u63D2\u5165HTML",
    visible: visible,
    onCancel: onCancel,
    onOk: function () {
      if (!isHtml(value)) {
        return Ant.message.error('需填入正確html');
      }
      onCancel();
      onInsert(value);
      setValue('');
    },
    okText: "\u78BA\u5B9A",
    cancelText: "\u53D6\u6D88"
  }, react_1.default.createElement(Wrapper, null, react_1.default.createElement("textarea", {
    value: value,
    onChange: function (e) {
      return setValue(e.target.value);
    }
  })));
}
exports.default = HtmlModal;
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 10px;\n  & > textarea {\n    margin: 0 auto;\n    width: 100%;\n    min-height: 300px;\n    border: solid 1px #aaa;\n  }\n"], ["\n  padding: 10px;\n  & > textarea {\n    margin: 0 auto;\n    width: 100%;\n    min-height: 300px;\n    border: solid 1px #aaa;\n  }\n"])));
var templateObject_1;